export default __webpack_public_path__ + "static/media/wegMWF.61c78b34.jpg";